/**
 * Returns a hex color (#rgb, #rrggbb, with or without an alpha pair) as CSS rgba() at the given
 * alpha, replacing any alpha the color already had. Other notations come back unchanged, an
 * empty color gives null.
 */
export function withAlpha(color, alpha) {
    if (!color || typeof color !== 'string') {
        return null;
    }
    const match = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.exec(color.trim());
    if (!match) {
        return color;
    }
    let hex = match[1];
    if (hex.length <= 4) {
        hex = hex.split('').map((digit) => digit + digit).join('');
    }
    const [r, g, b] = [0, 2, 4].map((offset) => parseInt(hex.slice(offset, offset + 2), 16));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
